import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://kirbooflowsafe.com';

const DEFAULT_DESCRIPTION =
  'KirBOO Flowsafe Pvt Ltd — trusted since 2005. Industrial valve, actuator, and pump services, spares, and 24/7 support across India. Founded as KirBOO Flowsafe in 2005; incorporated as Pvt Ltd in 2022.';

/** @type {Record<string, { title: string; description: string }>} */
const PAGE_SEO = {
  '/': {
    title: 'KirBOO Flowsafe Pvt Ltd | Valves, Actuators & Pump Services | Trusted Since 2005',
    description: DEFAULT_DESCRIPTION
  },
  '/about': {
    title: 'About Us | KirBOO Flowsafe Pvt Ltd | Since 2005',
    description:
      'Learn about KirBOO Flowsafe Pvt Ltd: founded in 2005 as KirBOO Flowsafe, incorporated in 2022. 25+ years of experience in valves, actuators, pumps, and spares with pan-India service.'
  },
  '/services': {
    title: 'Industrial Services | KirBOO Flowsafe Pvt Ltd',
    description:
      'Safety valves, control and isolation valves, ARC valves, actuators, pump services, genuine spares, and workshop support — KirBOO Flowsafe Pvt Ltd, trusted since 2005.'
  },
  '/services/safety-valve': {
    title: 'Safety Valve & Breather Valve Service | KirBOO Flowsafe',
    description:
      'Repair, testing, and spares for safety and breather valves. Shop and field service, all pressure classes. KirBOO Flowsafe Pvt Ltd — 25+ years experience.'
  },
  '/services/valve-service': {
    title: 'Control & Isolation Valve Service | KirBOO Flowsafe',
    description:
      'Valve repair and refurbishment from 150# to 4500# pressure class. Seat rebuilding, diagnostics, and on-site support across India.'
  },
  '/services/arc-valve': {
    title: 'ARC Valve Service | KirBOO Flowsafe Pvt Ltd',
    description:
      'Specialized ARC valve maintenance, repair, and performance optimization with emergency support from KirBOO Flowsafe.'
  },
  '/services/actuator': {
    title: 'Electric & Pneumatic Actuator Service | KirBOO Flowsafe',
    description:
      'Actuator maintenance, repair, and genuine spares for electric and pneumatic actuators. Factory-trained technicians.'
  },
  '/services/bfp-service': {
    title: 'Pump Services | KirBOO Flowsafe Pvt Ltd',
    description:
      'Pump breakdown, preventive, and shutdown maintenance with technical support. Serving industries across India.'
  },
  '/services/spares': {
    title: 'Genuine Industrial Spares | KirBOO Flowsafe',
    description:
      'SW gaskets, graphite packing, pressure seal rings, gland ropes, and reconditioning. Pan-India spare parts support.'
  },
  '/services/workshop': {
    title: 'Workshop Support & Machining | KirBOO Flowsafe',
    description:
      'Workshop facilities including CNC, VMC, grinding, finishing, and hardfacing for valve and component refurbishment.'
  },
  '/contact': {
    title: 'Contact Us | KirBOO Flowsafe Pvt Ltd | Navi Mumbai & Solapur',
    description:
      'Contact KirBOO Flowsafe Pvt Ltd: kirbooindia@gmail.com, +91 8329392431. Registered office Airoli, Navi Mumbai; works at Natepute, Solapur. Request a quote or service.'
  },
  '/careers': {
    title: 'Careers | KirBOO Flowsafe Pvt Ltd',
    description:
      'Join KirBOO Flowsafe Pvt Ltd — valve technicians and on-site service engineers. Apply with your CV; trusted industrial flow control employer since 2005.'
  },
  '/our-clients': {
    title: 'Our Clients | KirBOO Flowsafe Pvt Ltd',
    description:
      'Industries served by KirBOO Flowsafe: power, cement, oil & gas, and more. 25+ years of experience and trusted partnerships across India.'
  }
};

function setMeta(attr, name, content) {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function Seo() {
  const { pathname } = useLocation();
  const seo = pathname.startsWith('/admin') ? null : PAGE_SEO[pathname] || PAGE_SEO['/'];

  useEffect(() => {
    if (!seo) return;

    document.title = seo.title;
    setMeta('name', 'description', seo.description);
    setMeta('property', 'og:title', seo.title);
    setMeta('property', 'og:description', seo.description);
    setMeta('property', 'og:url', `${SITE_URL}${pathname === '/' ? '' : pathname}`);
    setMeta('name', 'twitter:title', seo.title);
    setMeta('name', 'twitter:description', seo.description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${SITE_URL}${pathname === '/' ? '/' : pathname}`);
  }, [pathname, seo]);

  return null;
}

export default Seo;
